import { useTranslation } from 'react-i18next'
import { SearchFilters } from './SearchFiltersContext'
import { X } from 'lucide-react'

interface ActiveFiltersProps {
  filters: SearchFilters
  onRemoveFilter: (type: string, value?: string) => void
}

export const ActiveFilters: React.FC<ActiveFiltersProps> = ({
  filters,
  onRemoveFilter,
}) => {
  const { t } = useTranslation()

  const storedFilters = localStorage.getItem('searchFilters')
  if (!storedFilters) {
    return null
  }

  const getActiveFilters = () => {
    const activeFilters = []

    if (filters.iLiveIn && filters.iLiveIn.length > 0) {
      activeFilters.push({
        type: 'location',
        value: filters.iLiveIn[0],
      })
    }

    if (filters.imLookingFor && filters.imLookingFor.length > 0) {
      activeFilters.push({
        type: 'looking',
        value: filters.imLookingFor
          .map(gender => t(`create-ad.${gender}`))
          .join(', '),
      })
    }

    if (filters.orientation && filters.orientation.length > 0) {
      activeFilters.push({
        type: 'orientation',
        value: filters.orientation.map(o => t(`create-ad.${o}`)).join(', '),
      })
    }

    if (filters.distance && filters.distance.length > 0) {
      activeFilters.push({
        type: 'distance',
        value: filters.distance[0],
      })
    }

    return activeFilters
  }

  const activeFilters = getActiveFilters()

  if (activeFilters.length === 0) return null

  return (
    <div className='mb-5 px-2 '>
      <div className='rounded-md bg-grisclair px-2'>
        <div className='flex flex-col lg:flex-row items-start sm:items-center text-xs xl:text-sm'>
          <div className='flex flex-wrap gap-2 py-2'>
            <div className='bg-blue-500 text-white pl-3 pr-2 py-1 rounded-md flex items-center gap-2 font-medium group'>
              <div className='flex items-center gap-1 '>
                <span className='font-medium'>{t('active-filters')}</span>
              </div>
            </div>
            {activeFilters
              .filter(filter => filter.value && filter.value !== 'create-ad.')
              .map(filter => (
                <div
                  key={filter.type}
                  className='bg-gray-200 ml-0 sm:ml-2 pl-1 xl:pl-3 pr-1 xl:pr-2 py-0 xl:py-1 rounded-md text-anthracite flex items-center gap-2 font-medium group flex-shrink-0'
                >
                  <div className='flex items-center gap-1 max-w-[200px] overflow-hidden'>
                    <span className='font-medium truncate'>
                      {t(`${filter.type}`)}
                    </span>
                    <span className='text-red-500 truncate'>
                      {filter.value}
                    </span>
                  </div>
                  <button
                    onClick={() => onRemoveFilter(filter.type)}
                    className='w-6 h-6 rounded flex items-center justify-center hover:bg-gray-300 transition-colors flex-shrink-0'
                    title={t('remove-filter')}
                  >
                    <X className='w-3 h-3 text-anthracite' />
                  </button>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}
